import * as React from 'react';

import { testAttribute } from 'src/utils/Serenity';
import { MarkdownWrapper } from '../MarkdownWrapper/MarkdownWrapper';
import styles from './ErrorPage.scss';

interface IErrorPageProps {
  title: string;
  blurb: string;
}

export const ErrorPage: React.FC<IErrorPageProps> = ({ title, blurb }) => (
  <section className={styles.errorPage}>
    <h1 data-test={testAttribute(title)}>{title}</h1>
    <MarkdownWrapper className={styles.errorBlurb} source={blurb} dataTestLinkAttr={`${testAttribute(title)}-link`} />
  </section>
);
